import React from 'react';
import classnames from 'classnames';

import styles from './Modal.module.scss';

export interface ModalProps {
  title: string;
  isVisible: boolean;
  btnClose: string | null;
  cssClass?: string | null;
  buttons?: { label: string; onClick: () => void }[];
  close: () => void;
}

const Modal: React.FC<ModalProps> = ({ title, btnClose, isVisible, cssClass, buttons, close, children }) => {
  const titleHtml = () => {
    return { __html: title };
  };

  return (
    <div data-testid='modal-container'>
      {isVisible && (
        <div data-testid='modal-overlay' className={styles.ff_modal_overlay}>
          <div className={classnames({ [cssClass || '']: cssClass }, styles.ff_modal)}>
            {btnClose && (
              <button className={classnames('btn', 'btn-primary', styles.ff_modal__footer__btn_close)} onClick={() => close()}>
                {btnClose}
              </button>
            )}

            <div className={styles.ff_modal__header}>
              <div className={styles.ff_modal__header__title} dangerouslySetInnerHTML={titleHtml()}></div>
            </div>

            <div className={styles.ff_modal__content}>{children}</div>

            {buttons && (
              <div className={styles.ff_modal__footer}>
                {buttons.map((button, index) => (
                  <button key={index} className={classnames('btn', 'btn-primary', styles.ff_modal__footer__btn)} onClick={() => button.onClick()}>
                    {button.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
